/*
  Dialog-Hülle für /shiftplan.

  Getragen wird sie vom MUI-Dialog – der bringt Fokusfalle, Escape, Klick
  daneben und Scroll-Sperre mit. Das Aussehen kommt aus den DS-Dialogklassen
  (.ds-dialog__*). Gleiche Bauweise wie der Schicht-Editor.

  Breite über `size` aus den DS-Tokens (sm/md/lg/xl). Der Rumpf bekommt keinen
  eigenen Innenabstand vorgeschrieben: die Inhalte hier reichen von randlosen
  Rastern bis zu normalen Formularen, das regelt jeder Aufrufer über
  `bodyClassName` selbst.
*/

import React, { useId } from "react";
import { Box, Dialog } from "@mui/material";
import { IconClose } from "../../../../design-system/icons";

export default function ShiftplanDialog({
  open,
  title,
  subtitle = "",
  icon = null,
  tone = "brand",
  size = "lg",
  headerActions = null,
  footerStart = null,
  footerActions = null,
  className = "",
  bodyClassName = "",
  onClose,
  children,
}) {
  const hasFooter = Boolean(footerStart || footerActions);
  // Benennt den Dialog über seinen Titel, wie AppDialogHeader im DS.
  const titleId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      aria-labelledby={titleId}
      className="spv2-dialog-root"
      BackdropProps={{ className: "spv2-dialog-backdrop" }}
      PaperProps={{ className: `spv2-dialog-paper is-${size}${className ? ` ${className}` : ""}` }}
    >
      <Box className="spv2-dialog">
        <Box className="ds-dialog__header spv2-dialog-header">
          {icon ? (
            <Box className={`ds-dialog__header-visual spv2-dialog-visual is-${tone}`} aria-hidden="true">
              {icon}
            </Box>
          ) : null}
          <Box className="ds-dialog__heading">
            {/* Schlichte Elemente statt MUI-Typography: so greifen die
                DS-Klassen ohne Spezifitätskampf mit den MUI-Grundstilen. */}
            <h3 id={titleId} className="ds-dialog__title">
              {title}
            </h3>
            {subtitle ? <p className="ds-dialog__subtitle">{subtitle}</p> : null}
          </Box>
          <Box className="ds-dialog__controls">
            {headerActions}
            <button type="button" className="ds-dialog__close" aria-label="Dialog schliessen" onClick={onClose}>
              <IconClose sx={{ fontSize: 18 }} />
            </button>
          </Box>
        </Box>

        <Box className={`spv2-dialog-body${bodyClassName ? ` ${bodyClassName}` : ""}`}>{children}</Box>

        {hasFooter ? (
          <Box className="ds-dialog__footer spv2-dialog-footer">
            {footerStart ? <Box className="ds-dialog__footer-start">{footerStart}</Box> : null}
            {footerActions ? <Box className="ds-dialog__footer-actions">{footerActions}</Box> : null}
          </Box>
        ) : null}
      </Box>
    </Dialog>
  );
}
